module.exports = __webpack_public_path__ + "static/media/banner.b6d05c1b.svg";